import { ApiUrl } from '@common/enums';
import { PredefinedShape } from '@common/models';

import { staticContentService } from '../staticContentService';

export type PredefinedShapesParams = void;

const predefinedShapesService = staticContentService.injectEndpoints({
    endpoints: (builder) => ({
        fetchPredefinedShapes: builder.query<PredefinedShape[], PredefinedShapesParams>({
            query: () => ({
                url: ApiUrl.PREDEFINED_SHAPES,
                method: 'GET',
            }),
        }),
    }),
});

export const { useFetchPredefinedShapesQuery } = predefinedShapesService;
